import { checkinLocale } from 'modules/checkin/presentation/locale';
import checkinRoutes from 'modules/checkin/presentation/routes';

const checkinModule = {
  routes: checkinRoutes,
  locale: checkinLocale,
};

export default checkinModule;
